// Visual representation of an Automation's steps. Vertical timeline-style
// list; each step shows its type and a short config summary.

interface Step {
  id: string;
  type: 'send_email' | 'delay' | 'wait_for_event' | 'end';
  config: Record<string, unknown>;
}

function configSummary(step: Step): string {
  if (step.type === 'send_email') {
    const t = (step.config as { template_id?: string }).template_id;
    return `template: ${t ?? '(none)'}`;
  }
  if (step.type === 'delay') {
    const d = (step.config as { duration?: { days?: number; hours?: number } }).duration;
    if (d?.days) return `${d.days} day${d.days !== 1 ? 's' : ''}`;
    if (d?.hours) return `${d.hours} hour${d.hours !== 1 ? 's' : ''}`;
    return '(no duration)';
  }
  if (step.type === 'wait_for_event') {
    const c = step.config as { eventName?: string; timeout?: { days?: number; hours?: number } };
    return `event: ${c.eventName ?? '(none)'} (timeout ${c.timeout?.days ?? c.timeout?.hours ?? '?'})`;
  }
  return '';
}

export function SequenceGraph({ steps }: { steps: Step[] }) {
  return (
    <ol className="space-y-2">
      {steps.map((s, i) => (
        <li key={s.id} className="flex gap-3">
          <div className="flex-shrink-0 w-6 text-foreground-mute text-xs font-mono pt-1">
            {i + 1}.
          </div>
          <div className="flex-1 bg-card border border-border rounded p-3">
            <div className="text-foreground text-sm">
              <span className="font-medium">{s.type}</span>
              <span className="text-foreground-mute"> · {s.id}</span>
            </div>
            <div className="text-foreground-mute text-xs mt-1">{configSummary(s)}</div>
          </div>
        </li>
      ))}
    </ol>
  );
}
